document.querySelectorAll('[data-apn]').forEach((root) => {
  const dataScript = root.querySelector('[data-apn-data]');
  if (!dataScript) return;

  let data;
  try {
    data = JSON.parse(dataScript.textContent || '{}');
  } catch (error) {
    return;
  }

  const media = data.media || [];
  const variants = data.variants || [];

  let currentMedia = media.find((item) => item.id === data.featuredMediaId) || media[0] || null;
  const selected = {};
  root.querySelectorAll('[data-apn-option][aria-current="true"]').forEach((button) => {
    selected[button.dataset.apnOption] = button.dataset.apnValue;
  });

  const updateCustomizationLink = () => {
    const link = root.querySelector('[data-apn-customization-link]');
    if (!link) return;

    const size = selected[link.dataset.apnCustomizationSizePosition];
    const messageLines = [
      link.dataset.apnCustomizationMessage,
      '',
      'Product: ' + data.productTitle
    ];
    if (size) messageLines.push('Size: ' + size);
    messageLines.push('Link: ' + link.dataset.apnCustomizationUrl);

    link.href = 'https://wa.me/' + link.dataset.apnCustomizationPhone + '?text=' + encodeURIComponent(messageLines.join('\n'));
  };

  updateCustomizationLink();

  const selectMedia = (item, options = {}) => {
    if (!item) return;
    currentMedia = item;
    const mediaIndex = media.findIndex((mediaItem) => mediaItem.id === item.id);
    root.querySelectorAll('[data-apn-thumb]').forEach((thumb) => {
      const thumbItem = media[Number(thumb.dataset.apnThumb)];
      const isCurrent = thumbItem && thumbItem.id === item.id;
      thumb.setAttribute('aria-current', isCurrent ? 'true' : 'false');
      if (isCurrent && options.scrollThumb !== false) {
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    });
    const holder = root.querySelector('[data-apn-main-media]');
    holder?.querySelectorAll('[data-apn-main-slide]').forEach((slide) => {
      slide.setAttribute('aria-current', Number(slide.dataset.apnMainSlide) === mediaIndex ? 'true' : 'false');
    });
    if (options.scrollMain !== false && holder && window.matchMedia('(max-width: 640px)').matches && mediaIndex >= 0) {
      holder.scrollTo({ left: mediaIndex * holder.clientWidth, behavior: options.behavior || 'smooth' });
    }
  };

  const lightbox = root.querySelector('[data-apn-lightbox]');
  const lightboxImage = root.querySelector('[data-apn-lightbox-image]');
  const mainMedia = root.querySelector('[data-apn-main-media]');
  let lightboxScale = 1;

  const setLightboxScale = (scale) => {
    lightboxScale = Math.min(3, Math.max(1, scale));
    if (lightboxImage) {
      lightboxImage.style.setProperty('--apn-zoom-scale', lightboxScale);
    }
  };

  const lightboxCounter = root.querySelector('[data-apn-lightbox-counter]');
  const lightboxPrev = root.querySelector('[data-apn-lightbox-prev]');
  const lightboxNext = root.querySelector('[data-apn-lightbox-next]');

  const showLightboxImage = (item) => {
    if (!lightboxImage || !item) return;
    lightboxImage.src = item.zoomSrc || item.src;
    lightboxImage.alt = item.alt || data.productTitle;
    setLightboxScale(1);
    const index = media.findIndex((mediaItem) => mediaItem.id === item.id);
    if (lightboxCounter) {
      if (media.length > 1 && index >= 0) {
        lightboxCounter.hidden = false;
        lightboxCounter.textContent = (index + 1) + ' / ' + media.length;
      } else {
        lightboxCounter.hidden = true;
      }
    }
  };

  const navigateLightbox = (direction) => {
    if (media.length < 2) return;
    const currentIndex = media.findIndex((item) => item.id === (currentMedia || media[0]).id);
    const nextIndex = (currentIndex + direction + media.length) % media.length;
    const item = media[nextIndex];
    selectMedia(item);
    showLightboxImage(item);
  };

  const openLightbox = () => {
    const image = currentMedia || media[0];
    if (!lightbox || !lightboxImage || !image) return;
    showLightboxImage(image);
    lightbox.setAttribute('aria-hidden', 'false');
    root.classList.add('is-lightbox-open');
    document.documentElement.style.overflow = 'hidden';
    if (lightboxPrev && lightboxNext) {
      const showArrows = media.length > 1;
      lightboxPrev.hidden = !showArrows;
      lightboxNext.hidden = !showArrows;
    }
    root.querySelector('[data-apn-lightbox-close]')?.focus();
  };

  const closeLightbox = () => {
    if (!lightbox) return;
    lightbox.setAttribute('aria-hidden', 'true');
    root.classList.remove('is-lightbox-open');
    document.documentElement.style.overflow = '';
    mainMedia?.focus();
  };

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, data.moneyFormat);
    }

    const format = data.moneyFormat || '₹{{amount}}';
    const amount = Number(cents || 0) / 100;
    const formatWithSeparators = (value, decimals, thousandsSeparator, decimalSeparator) => {
      const parts = value.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
      return parts.length > 1 ? parts[0] + decimalSeparator + parts[1] : parts[0];
    };
    const replacements = {
      amount: formatWithSeparators(amount, 2, ',', '.'),
      amount_no_decimals: formatWithSeparators(amount, 0, ',', '.'),
      amount_with_comma_separator: formatWithSeparators(amount, 2, '.', ','),
      amount_no_decimals_with_comma_separator: formatWithSeparators(amount, 0, '.', ','),
      amount_with_apostrophe_separator: formatWithSeparators(amount, 2, "'", '.')
    };

    return format.replace(
      /\{\{\s*(amount(?:_no_decimals)?(?:_with_(?:comma|apostrophe)_separator)?)\s*\}\}/g,
      (placeholder, key) => replacements[key] ?? placeholder
    );
  };

  const updateVariant = () => {
    if (!variants.length) return;
    const variant = variants.find((item) => {
      return item.options.every((value, index) => selected[String(index + 1)] === value);
    });
    if (!variant) return;
    const input = root.querySelector('[data-apn-variant-id]');
    if (input) input.value = variant.id;
    root.querySelectorAll('.apn__add').forEach((button) => {
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    });
    const priceEl = root.querySelector('[data-apn-price]');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    const priceRow = root.querySelector('.apn__price-row');
    if (priceRow) {
      let mrpEl = priceRow.querySelector('.apn__price-mrp');
      let badgeEl = priceRow.querySelector('[data-apn-discount-badge]');
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        if (!mrpEl) {
          mrpEl = document.createElement('span');
          mrpEl.className = 'apn__price-mrp';
          priceRow.appendChild(mrpEl);
        }
        mrpEl.innerHTML = 'MRP <s data-apn-compare-price>' + formatMoney(variant.compare_at_price) + '</s>';
        if (!badgeEl) {
          badgeEl = document.createElement('span');
          badgeEl.className = 'apn__price-badge';
          badgeEl.dataset.apnDiscountBadge = '';
          priceRow.appendChild(badgeEl);
        }
        badgeEl.textContent = '(' + pct + '% OFF)';
      } else {
        mrpEl && mrpEl.remove();
        badgeEl && badgeEl.remove();
      }
    }
    if (variant.featured_media && variant.featured_media.id) {
      selectMedia(media.find((item) => item.id === variant.featured_media.id));
    }
  };

  root.querySelectorAll('[data-apn-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const item = media[Number(button.dataset.apnThumb)];
      if (!item) return;
      selectMedia(item);
    });
  });

  const syncMainScrollSelection = (holder) => {
    const index = Math.min(
      media.length - 1,
      Math.max(0, Math.round(holder.scrollLeft / Math.max(holder.clientWidth, 1)))
    );
    const item = media[index];
    if (!item) return;
    selectMedia(item, { scrollMain: false });
  };

  let mainMediaScrollFrame = null;
  let mainMediaScrollTimer = null;
  root.querySelector('[data-apn-main-media]')?.addEventListener('scroll', (event) => {
    if (!window.matchMedia('(max-width: 640px)').matches) return;
    const holder = event.currentTarget;
    if (mainMediaScrollFrame) window.cancelAnimationFrame(mainMediaScrollFrame);
    if (mainMediaScrollTimer) window.clearTimeout(mainMediaScrollTimer);
    mainMediaScrollFrame = window.requestAnimationFrame(() => {
      syncMainScrollSelection(holder);
    });
    mainMediaScrollTimer = window.setTimeout(() => {
      syncMainScrollSelection(holder);
    }, 120);
  }, { passive: true });

  const thumbs = root.querySelector('[data-apn-thumbs]');
  const scrollThumbs = (direction) => {
    if (!thumbs) return;
    const horizontal = window.matchMedia('(max-width: 640px)').matches;
    const amount = horizontal ? 92 : 106;
    thumbs.scrollBy({
      left: horizontal ? direction * amount : 0,
      top: horizontal ? 0 : direction * amount,
      behavior: 'smooth'
    });
  };

  root.querySelector('[data-apn-thumbs-prev]')?.addEventListener('click', () => scrollThumbs(-1));
  root.querySelector('[data-apn-thumbs-next]')?.addEventListener('click', () => scrollThumbs(1));

  root.querySelectorAll('[data-apn-option]').forEach((button) => {
    button.addEventListener('click', () => {
      const group = button.dataset.apnOption;
      selected[group] = button.dataset.apnValue;
      root.querySelectorAll(`[data-apn-option="${group}"]`).forEach((peer) => peer.setAttribute('aria-current', 'false'));
      button.setAttribute('aria-current', 'true');
      if (button.classList.contains('apn__swatch')) {
        const label = root.querySelector('[data-apn-selected-color]');
        if (label) label.textContent = button.dataset.apnValue;
      }
      if (button.classList.contains('apn__size')) {
        const label = root.querySelector('[data-apn-selected-size]');
        if (label) label.textContent = button.dataset.apnValue;
        updateCustomizationLink();
      }
      updateVariant();
    });
  });

  root.querySelectorAll('.apn__swatch:not([data-apn-option]), .apn__size:not([data-apn-option])').forEach((button) => {
    button.addEventListener('click', () => {
      const selector = button.classList.contains('apn__swatch') ? '.apn__swatch' : '.apn__size';
      root.querySelectorAll(selector).forEach((peer) => peer.setAttribute('aria-current', 'false'));
      button.setAttribute('aria-current', 'true');
      const label = button.classList.contains('apn__swatch') ? root.querySelector('[data-apn-selected-color]') : root.querySelector('[data-apn-selected-size]');
      if (label) label.textContent = button.title || button.textContent.trim();
    });
  });

  root.querySelectorAll('.apn__accordion-trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.apn__accordion');
      const open = item.classList.toggle('is-open');
      const icon = trigger.querySelector('.apn__accordion-icon');
      if (icon) icon.textContent = open ? '-' : '+';
    });
  });

  const qty = root.querySelector('[data-apn-qty]');
  root.querySelector('[data-apn-qty-minus]')?.addEventListener('click', () => {
    qty.value = Math.max(1, Number(qty.value || 1) - 1);
  });
  root.querySelector('[data-apn-qty-plus]')?.addEventListener('click', () => {
    qty.value = Number(qty.value || 1) + 1;
  });

  const addToCartForm = root.querySelector('form[data-type="add-to-cart-form"]');
  const cartDrawerEl = document.querySelector('cart-drawer');

  addToCartForm?.addEventListener('submit', async (event) => {
    // Only the explicit Add to Cart button should use the AJAX cart-drawer flow.
    const addToCartButton = event.submitter?.closest('.apn__add');
    if (!addToCartButton || !addToCartForm.contains(addToCartButton)) return;
    event.preventDefault();
    if (addToCartButton.disabled) return;

    const originalLabel = addToCartButton.textContent;
    addToCartButton.disabled = true;
    addToCartButton.textContent = 'Adding…';

    const formData = new FormData(addToCartForm);
    if (cartDrawerEl) {
      formData.append('sections', cartDrawerEl.getSectionsToRender().map((cartSection) => cartSection.id));
      formData.append('sections_url', window.location.pathname);
    }

    try {
      const response = await fetch(data.cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });
      const responseData = await response.json();

      if (responseData.status) {
        addToCartButton.textContent = responseData.description || responseData.message || 'Could not add to cart';
        setTimeout(() => {
          addToCartButton.textContent = originalLabel;
        }, 2200);
        return;
      }

      if (cartDrawerEl) {
        cartDrawerEl.renderContents(responseData);
      } else {
        window.location = data.cartUrl;
        return;
      }

      addToCartButton.textContent = originalLabel;
    } catch (error) {
      addToCartButton.textContent = originalLabel;
    } finally {
      addToCartButton.disabled = false;
    }
  });

  mainMedia?.addEventListener('click', (event) => {
    if (event.target.closest('[data-apn-zoom]')) return;
    openLightbox();
  });
  mainMedia?.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    openLightbox();
  });
  root.querySelector('[data-apn-zoom]')?.addEventListener('click', (event) => {
    event.stopPropagation();
    openLightbox();
  });
  root.querySelector('[data-apn-lightbox-zoom-in]')?.addEventListener('click', () => {
    setLightboxScale(lightboxScale + .25);
  });
  root.querySelector('[data-apn-lightbox-zoom-out]')?.addEventListener('click', () => {
    setLightboxScale(lightboxScale - .25);
  });
  root.querySelector('[data-apn-lightbox-reset]')?.addEventListener('click', () => {
    setLightboxScale(1);
  });
  root.querySelector('[data-apn-lightbox-close]')?.addEventListener('click', closeLightbox);
  lightboxPrev?.addEventListener('click', (event) => {
    event.stopPropagation();
    navigateLightbox(-1);
  });
  lightboxNext?.addEventListener('click', (event) => {
    event.stopPropagation();
    navigateLightbox(1);
  });
  lightbox?.addEventListener('click', (event) => {
    if (event.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', (event) => {
    if (!root.classList.contains('is-lightbox-open')) return;
    if (event.key === 'Escape') {
      closeLightbox();
    } else if (event.key === 'ArrowLeft') {
      navigateLightbox(-1);
    } else if (event.key === 'ArrowRight') {
      navigateLightbox(1);
    }
  });

  const drawer = root.querySelector('[data-apn-drawer]');
  const items = root.querySelector('[data-apn-wish-items]');
  const count = root.querySelector('[data-apn-wish-count]');
  const foot = root.querySelector('.apn__drawer-foot');
  const addAllButton = root.querySelector('[data-apn-add-all]');
  let wishlistCartItems = [];

  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  const getWishlistHandles = () => {
    if (window.Wishlist && typeof window.Wishlist.get === 'function') return window.Wishlist.get();
    try {
      const stored = JSON.parse(localStorage.getItem('shopify_wishlist'));
      return Array.isArray(stored) ? stored : [];
    } catch (e) {
      return [];
    }
  };

  const openDrawer = () => {
    root.classList.add('is-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    renderWish();
  };

  const closeDrawer = () => {
    root.classList.remove('is-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
  };

  const emptyDrawerHtml = () => (
    '<div class="apn__drawer-empty"><svg width="42" height="42" viewBox="0 0 22 22" fill="none" stroke="#d6c6ad" stroke-width="1.2" style="margin:0 auto;"><path d="M11 18.5S3 13.8 3 8.6C3 5.9 5.1 4 7.5 4c1.7 0 3 1 3.5 1.8C11.5 5 12.8 4 14.5 4 16.9 4 19 5.9 19 8.6c0 5.2-8 9.9-8 9.9Z"></path></svg><p>Your wishlist is empty</p><p>Tap the heart on any piece to save it here.</p></div>'
  );

  async function renderWish() {
    const handles = getWishlistHandles();
    count.textContent = handles.length;
    wishlistCartItems = [];
    if (foot) foot.hidden = true;
    if (addAllButton) {
      addAllButton.disabled = true;
      addAllButton.textContent = 'Add All to Cart';
    }

    if (!handles.length) {
      items.innerHTML = emptyDrawerHtml();
      return;
    }

    items.innerHTML = '<div class="apn__drawer-empty"><p>Loading wishlist...</p></div>';

    const products = await Promise.all(handles.map((handle) =>
      fetch(`/products/${encodeURIComponent(handle)}.js`)
        .then((response) => response.ok ? response.json() : null)
        .catch(() => null)
    ));

    const validProducts = products.filter(Boolean);
    if (!validProducts.length) {
      items.innerHTML = emptyDrawerHtml();
      return;
    }

    wishlistCartItems = validProducts
      .map((product) => {
        const variant = (product.variants || []).find((item) => item.available);
        return variant ? { id: Number(variant.id), quantity: 1 } : null;
      })
      .filter(Boolean);

    if (foot) foot.hidden = !wishlistCartItems.length;
    if (addAllButton) addAllButton.disabled = !wishlistCartItems.length;

    items.innerHTML = validProducts.map((product) => {
      const variant = (product.variants || []).find((item) => item.available) || (product.variants || [])[0];
      const image = product.featured_image ? product.featured_image.replace(/(\.\w+)$/, '_120x120$1') : '';
      const price = variant ? variant.price : product.price;
      const available = variant && variant.available;

      return `
        <div class="apn__drawer-item" data-apn-wishlist-card="${escapeHtml(product.handle)}">
          <a class="apn__drawer-swatch" href="/products/${escapeHtml(product.handle)}" aria-label="${escapeHtml(product.title)}">
            ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" loading="lazy" width="120" height="120">` : ''}
          </a>
          <div style="flex:1;min-width:0;">
            <a class="apn__drawer-name" href="/products/${escapeHtml(product.handle)}" style="text-decoration:none;">${escapeHtml(product.title)}</a>
            <div class="apn__drawer-price">${formatMoney(price)}</div>
            <div class="apn__drawer-actions">
              <button class="apn__drawer-cart" type="button" data-apn-drawer-cart="${variant ? variant.id : ''}" ${available ? '' : 'disabled'}>${available ? 'Add to cart' : 'Sold out'}</button>
              <button class="apn__drawer-remove" type="button" data-apn-remove="${escapeHtml(product.handle)}" title="Remove">&times;</button>
            </div>
          </div>
        </div>
      `;
    }).join('');

    items.querySelectorAll('[data-apn-remove]').forEach((button) => {
      button.addEventListener('click', () => {
        if (window.Wishlist) window.Wishlist.remove(button.dataset.apnRemove);
        renderWish();
      });
    });

    items.querySelectorAll('[data-apn-drawer-cart]').forEach((button) => {
      button.addEventListener('click', async () => {
        const variantId = button.dataset.apnDrawerCart;
        if (!variantId) return;
        button.disabled = true;
        button.textContent = 'Adding...';
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
          });
          button.textContent = response.ok ? 'Added' : 'Try again';
        } catch (e) {
          button.textContent = 'Try again';
        }
        setTimeout(() => {
          button.disabled = false;
          button.textContent = 'Add to cart';
        }, 1400);
      });
    });
  }

  addAllButton?.addEventListener('click', async () => {
    if (!wishlistCartItems.length) return;
    addAllButton.disabled = true;
    addAllButton.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: wishlistCartItems })
      });

      addAllButton.textContent = response.ok ? 'Added all' : 'Try again';
    } catch (e) {
      addAllButton.textContent = 'Try again';
    }

    setTimeout(() => {
      addAllButton.disabled = !wishlistCartItems.length;
      addAllButton.textContent = 'Add All to Cart';
    }, 1600);
  });

  root.querySelectorAll('[data-apn-close-drawer]').forEach((node) => {
    node.addEventListener('click', closeDrawer);
  });

  document.addEventListener('wishlist:updated', () => {
    renderWish();
  });

  renderWish();
});
